import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { SalesforceUserSelector } from '@ui/SalesforceUserSelector';
import { UpdateQueryParams } from '@hooks';
import React, { useCallback } from 'react';

export type ModifiedByFilterParams = { modifiedByUsernames?: string[] };

export interface ModifiedByFilterProps {
	disabled?: boolean;
	onChange: UpdateQueryParams<ModifiedByFilterParams>;
	value?: Array<string>;
}

export const ModifiedByFilter: React.FC<ModifiedByFilterProps> = ({ disabled, onChange, value }) => {
	const handleOnChange = useCallback((modifiedByUsernames: string[]) => {
		onChange({ modifiedByUsernames });
	}, [ onChange ]);

	return (
		<SalesforceUserSelector
			allowReadonly
			disabled={ disabled }
			onChange={ handleOnChange }
			placeholder={ COPY_SPECIFIC.SELECT_ADMIN }
			value={ value } />
	);
};
